import React, { useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import trans from 'translate';
import TokensPercentagesBar from '../../../../Common/TokensPercentagesBar/TokensPercentagesBar';
import TokensPercentagesFullList from '../../../../Common/TokensPercentagesFullList/TokensPercentagesFullList';
import { hPoolSignTransactionContext } from '../CreateHPoolSignTransaction';
import SignTradeOrders from '../SignTradeOrders/SignTradeOrders';
import { createOrUpdateHPoolAction } from '../../../../../redux/actions/createHPoolActions';
import { createNotification } from '../../../../../redux/actions/uiActions';
import { generateColor } from '../../../../../utils/colors';
import { useAssetsSignatures } from '../../../../../hooks/useAssetsSignatures';
import CreateHPoolControls from '../../CreateHPoolControls/CreateHPoolControls';
import config from '../../../../../config/config.json';

const SignOnOverview = ({ goToPreviousStep, createNotification, assetSignatures, standalone }) => {
  const { tradeOrders, addedTokens } = useContext(hPoolSignTransactionContext);
  const [, setAssetSigantures, , , , unSignedTxs] = useAssetsSignatures('BuyOrderRatio');

  const tradeOrdersWithoutEth = useMemo(
    () =>
      tradeOrders?.filter((tradeOrder) => tradeOrder.token_symbol.toLowerCase() !== config.baseCoin.toLowerCase()) ||
      [],
    [tradeOrders.length],
  );

  const unsignedTradeOrders = useMemo(
    () => tradeOrdersWithoutEth.filter((tradeOrder) => !tradeOrder.is_signed),
    [tradeOrdersWithoutEth],
  );

  const addColorToToken = (token) => {
    if (token.color) return token;
    const color = generateColor(token.token_name || token.name);
    return { ...token, color };
  };
  const tokenWithColors = addedTokens?.map?.(addColorToToken) || [];
  const signAllTx = async () => {
    try {
      await Promise.all(
        tradeOrdersWithoutEth
          .filter((tradeOrder) => !Object.keys(assetSignatures).includes(tradeOrder.token_id.toString()))
          .map(async (tradeOrder) => {
            setAssetSigantures(tradeOrder);
          }),
      );
    } catch (error) {
      createNotification('error', error.message, 4000);
    }
  };

  return (
    <>
      <p>{trans('hpool.sign_tx_modal_title')}</p>
      <hr />
      <SignTradeOrders hiddenCols={['amount', 'tokenUsTotal', 'tokenEthTotal']} tradeOrders={tradeOrdersWithoutEth} />

      <TokensPercentagesBar tokens={tokenWithColors} />

      <div className="tokens-percentages-list">
        <TokensPercentagesFullList tokens={tokenWithColors} />
      </div>

      {standalone ? (
        <CreateHPoolControls noBack={!unSignedTxs.length} disabled={!!unSignedTxs.length} />
      ) : (
        <div className="create-hpool-controls-wrapper">
          <div className="right-button-wrapper">
            {/* <Button text="hpool.sign_all" className="button green" onClick={signAllTx} /> */}
            <div className="skip" onClick={goToPreviousStep}>
              Cancel
            </div>
          </div>
        </div>
      )}
    </>
  );
};

SignOnOverview.defaultProps = {
  assetSignatures: {},
  standalone: false,
};

SignOnOverview.propTypes = {
  goToPreviousStep: PropTypes.func.isRequired,
  createNotification: PropTypes.func.isRequired,
  assetSignatures: PropTypes.object,
  standalone: PropTypes.bool,
};

const mapStateToProps = ({ createHPool }) => ({
  assetSignatures: createHPool.assetSignatures,
  hPoolId: createHPool.hpool.id,
});

export default connect(mapStateToProps, { createOrUpdateHPoolAction, createNotification })(SignOnOverview);
